import request from "@/utils/request";

export function indexNews(query) {
  return request({
    url: `api/admin-panel/posts`,
    method: "get",
    params: { ...query }
  });
}
export function getNews() {
  return request({
    url: `api/admin-panel/news`,
    method: "get"
  });
}
export function showNews(slug, locale) {
  return request({
    url: `api/admin-panel/posts/${slug}`,
    method: "get",
    headers: { "X-locale": locale }
  });
}
export function getTags() {
  return request({
    url: `/api/admin-panel/tags`,
    method: "get"
  });
}

export function storeNews(data) {
  return request({
    url: "api/admin-panel/posts",
    method: "post",
    data
  });
}
export function updateNews(data, slug) {
  return request({
    url: `api/admin-panel/posts/${slug}`,
    method: "post",
    data
  });
}
export function deleteNews(slug) {
  return request({
    url: `api/admin-panel/posts/${slug}`,
    method: "delete"
  });
}
export function getfilterTags() {
  return request({
    url: `api/admin-panel/tags?model=news`,
    method: "get"
  });
}
